import { BACKEND_URL } from "config/getUrl";

// Gets the frontend settings through an unprotected backend route
export const getFrontendSettingsRequest = async() => {
  // Perform the request
  const response = await fetch(
    `${BACKEND_URL}${'/api/frontend_settings'}`
  );

  // Check if the status of the answer is ok
  if (!(response.status === 200))
    return {
      message: `Request status: ${response.status}`,
      successful: false,
      logout: false,
    };

  // Get the response
  const data = await response.json();

  // Return the data
  return data;
}